module.exports = __webpack_public_path__ + "img/qepcopytree.d1ff2e00.png";